module.exports = __webpack_public_path__ + "static/media/icon-payment-methods.347fcc1b.png";